import React from 'react';

import { Global } from '@emotion/react';
import styled from '@emotion/styled';

import { callNativeHandler } from '@myrealtrip/marketing-log';
import { NavigationTitle, Icon, UnstyledButton } from '@myrealtrip/web-ui';

import Show from '~components/Show';
import { useWebView } from '@myrealtrip/device-detect';
import errorGlobalStyle from '~styles/errorGlobals';

export default function Error500() {
  const { isWebView } = useWebView();

  const handleCloseSearch = () => {
    try {
      callNativeHandler('close');
    } catch (error) {
      window.close();
    }
  };

  return (
    <ErrorContainer>
      <Global styles={errorGlobalStyle} />
      <Show when={isWebView}>
        <CustomNavigationTitle
          type="oneDepth"
          justify="flex-start"
          rightGroup={
            isWebView && (
              <Button onClick={handleCloseSearch}>
                <Icon name="IcoClose" />
              </Button>
            )
          }
        />
      </Show>
      <ErrorCover>
        <ErrorHeader className="error-text">
          <ErrorTitle>500</ErrorTitle>
          <ErrorDescription>
            죄송합니다.
            <CarriageReturn /> 서비스 이용이 원활하지 않습니다.
          </ErrorDescription>
          <ErrorSubDescription>
            문제가 발생하였습니다. 잠시 후 다시 시도해주세요.
          </ErrorSubDescription>
        </ErrorHeader>
        <ErrorImage src="/transportation/assets/500Image.png" alt="Building" />
      </ErrorCover>
    </ErrorContainer>
  );
}

const ErrorContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 60px 30px;

  @media (min-width: 768px) {
    padding: 60px 0;
  }
`;

const CustomNavigationTitle = styled(NavigationTitle)`
  position: absolute;
  top: 0;
  left: 0;
`;

const Button = styled(UnstyledButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;

  & svg {
    fill: ${({ theme }) => theme.colors.gray.s1000};
  }
`;

const ErrorCover = styled.div`
  position: relative;
  width: 600px;
  max-width: 100%;

  @media (min-width: 768px) {
    height: 360px;
  }
`;

const ErrorHeader = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Malgun Gothic', '맑은 고딕', Roboto, Helvetica,
    Arial, sans-serif;
  padding: 0 0 40px;
  width: 100%;

  @media (min-width: 768px) {
    padding: 0 15px;
  }
`;

const ErrorTitle = styled.h2`
  color: #666d75;
  font-family: inherit;
  font-weight: 500;
  font-size: 58px;
  margin: 0;
`;

const ErrorDescription = styled.p`
  margin: 0;
  font-size: 18px;
  color: #666d75;
`;

const ErrorSubDescription = styled.p`
  margin-top: 5px;
  font-size: 12px;
  color: #666d75;
`;

const CarriageReturn = styled.br`
  display: none;

  @media (max-width: 767px) {
    display: block;
  }
`;

const ErrorImage = styled.img`
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    width: 324px;
    max-width: 100%;
  }
`;
